import dataType from '../dataType';

const matchingKey = {
    name: 'MatchingKey_Client',
    type: dataType.string
};

export default matchingKey;
